import Utils from "framework7/utils/utils";
import $ from "dom7";

export default  {
  methods: {
    searchFromBeginning(sb, query, prevQuery){

      let foundItems = [];
      let $searchContainer = sb.$searchContainer;
      let $notFoundEl = sb.$notFoundEl;
      let $foundEl = sb.$foundEl;

//
      let values;
      if (sb.params.removeDiacritics) values = Utils.removeDiacritics(query.trim().toLowerCase()).split(' ');
      else {
        values = query.trim().toLowerCase().split(' ');
      }
      $searchContainer.find(sb.params.searchItem).removeClass('hidden-by-searchbar').each((itemIndex, itemEl) => {
        const $itemEl = $(itemEl);
        let compareWithText = [];
        let $searchIn = sb.params.searchIn ? $itemEl.find(sb.params.searchIn) : $itemEl;
        if (sb.params.searchIn === sb.params.searchItem) {
          $searchIn = $itemEl;
        }
        $searchIn.each((searchInIndex, searchInEl) => {
          let itemText = $(searchInEl).text().trim().toLowerCase();
          if (sb.params.removeDiacritics) itemText = Utils.removeDiacritics(itemText);
          compareWithText.push(itemText);
        });
        compareWithText = compareWithText.join(' ');
        let wordsMatch = 0;
        for (let i = 0; i < values.length; i += 1) {
          if (compareWithText.indexOf(values[i]) === 0) wordsMatch += 1;
        }
        if (wordsMatch !== values.length && !(sb.params.ignore && $itemEl.is(sb.params.ignore))) {
          $itemEl.addClass('hidden-by-searchbar');
        } else {
          foundItems.push($itemEl[0]);
        }
      });

      if (foundItems.length === 0) {
        if ($notFoundEl) $notFoundEl.show();
        if ($foundEl) $foundEl.hide();
      } else {
        if ($notFoundEl) $notFoundEl.hide();
        if ($foundEl) $foundEl.show();
      }

      return sb;

    },

    getTemperatureColor(temp) {
      const limits = [
        {color:'#7FB3D5', f_color:'#000000', limit:-24},
        {color:'#2980B9', f_color:'#000000', limit:-22},
        {color:'#1F618D', f_color:'#ffffff', limit:-20},
        {color:'#1B4F72', f_color:'#ffffff', limit:-18},
        {color:'#000033', f_color:'#ffffff', limit:-16},
        {color:'#000066', f_color:'#ffffff', limit:-14},
        {color:'#000099', f_color:'#ffffff', limit:-12},
        {color:'#0000cc', f_color:'#ffffff', limit:-10},
        {color:'#0000ff', f_color:'#ffffff', limit:-8},
        {color:'#3f3fff', f_color:'#ffffff', limit:-6},
        {color:'#7f7fff', f_color:'#000000', limit:-4},
        {color:'#bfbfff', f_color:'#000000', limit:-2},
        {color:'#ffffff', f_color:'#000000', limit:0},
        {color:'#bfffbf', f_color:'#000000', limit:2},
        {color:'#7fff7f', f_color:'#000000', limit:4},
        {color:'#3fff3f', f_color:'#000000', limit:6},
        {color:'#00ff00', f_color:'#000000', limit:8},
        {color:'#3fff00', f_color:'#000000', limit:10},
        {color:'#7fff00', f_color:'#000000', limit:12},
        {color:'#bfff00', f_color:'#000000', limit:14},
        {color:'#ffff00', f_color:'#000000', limit:16},
        {color:'#ffe800', f_color:'#000000', limit:18},
        {color:'#ffd200', f_color:'#000000', limit:20},
        {color:'#ffbb00', f_color:'#000000', limit:22},
        {color:'#ffa500', f_color:'#000000', limit:24},
        {color:'#ff7b00', f_color:'#000000', limit:26},
        {color:'#ff5200', f_color:'#000000', limit:28},
        {color:'#ff2800', f_color:'#000000', limit:30},
        {color:'#ff0000', f_color:'#000000', limit:32},
        {color:'#cc0000', f_color:'#ffffff', limit:34},
        {color:'#990000', f_color:'#ffffff', limit:36},
        {color:'#660000', f_color:'#ffffff', limit:38}
        ];

      let res = false;

      if (temp > limits[limits.length-1].limit) {
        res = limits[limits.length - 1];
      }


      limits.some(function(limit_def) {
        if (temp <= limit_def.limit) {
          res = limit_def;
          return true;
        }
        return false;
      });

      return res;
    },

    getWindSpeedColor(speed) {
      const limits = [
        {color:'#ffffcc',f_color:'#000000',limit:2},
        {color:'#fff1ac',f_color:'#000000',limit:4},
        {color:'#fee38c',f_color:'#000000',limit:6},
        {color:'#fed16e',f_color:'#000000',limit:8},
        {color:'#feb550',f_color:'#000000',limit:10},
        {color:'#fd9a41',f_color:'#000000',limit:12},
        {color:'#fc7635',f_color:'#000000',limit:14},
        {color:'#f94a28',f_color:'#ffffff',limit:16},
        {color:'#e7231e',f_color:'#ffffff',limit:18},
        {color:'#ce0c22',f_color:'#ffffff',limit:20},
        {color:'#ac0027',f_color:'#ffffff',limit:22},
        {color:'#800027',f_color:'#ffffff',limit:24},
      ];

      let res = false;

      if (speed > limits[limits.length-1].limit) {
        res = limits[limits.length - 1];
      }


      limits.some(function(limit_def) {
        if (speed <= limit_def.limit) {
          res = limit_def;
          return true;
        }
        return false;
      });

      return res;

    }

  }
}
